// File: src/pages/targets/TargetTabs.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";

import HierarchyWiseTarget from "./HierarchyWiseTarget";
import AutoTarget from "./AutoTarget";
import ProfitWiseReport from "./ProfitWiseReport";
import YearlyTarget from "./YearlyTarget";
import SalesManagerTargetTab from "./targets/SalesManagerTargetTab";
import SalesPersonTargetTab from "./targets/SalesPersonTargetTab";
import CustomerTargetTab from "./targets/CustomerTargetTab";
import YearlyTargetTab from "./targets/YearlyTargetTab";
import AutoCompanyTarget from "./AutoCompanyTarget";

/* ========= Inline CSS (once) ========= */
const injectOnce = () => {
  if (document.getElementById("target-tabs-inline-css")) return;
  const s = document.createElement("style");
  s.id = "target-tabs-inline-css";
  s.textContent = `
    .tt-nav { border-bottom:1px solid #e5e7eb; background:#fff; border-radius:12px; padding:4px; overflow:auto; }
    .tt-link { cursor:pointer; font-weight:800; letter-spacing:.02em; padding:8px 12px; margin:4px; border-radius:999px; color:#0f172a; white-space:nowrap; display:inline-flex; align-items:center; gap:8px; }
    .tt-link.active { background:#1747ff; color:#fff; }

    .tt-body { border:1px solid #e5e7eb; border-radius:14px; background:#fff; }
    .fb { padding:12px; color:#6b7280; display:flex; align-items:center; gap:10px; flex-wrap:wrap; }
  `;
  document.head.appendChild(s);
};

export default function TargetTabs() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => injectOnce(), []);

  const getTabFromQueryRaw = (search) => {
    const params = new URLSearchParams(search);
    return params.get("tab");
  };

  const tabs = useMemo(
    () => [
      { key: "targetFlow", label: "YEARLY TARGET" },
      { key: "autoTarget", label: "AUTO COMPANY TARGET" },
      { key: "smTarget", label: "SM TARGET" },
      // { key: "autoTarget", label: "AUTO SM TARGET" },
      { key: "spTarget", label: "SP TARGET" },
      // { key: "autoTarget", label: "AUTO SP TARGET" },
      { key: "customerTarget", label: "CUSTOMER TARGET" },
      // { key: "autoTarget", label: "AUTO CUSTOMER TARGET" },
      { key: "profitWiseReport", label: "PROFIT WISE REPORT" },
    ],
    [],
  );

  const [active, setActive] = useState(() => {
    const fromQuery = getTabFromQueryRaw(location.search);
    const fromStorage = localStorage.getItem("TargetTabsActive");
    return fromQuery || fromStorage || "targetFlow";
  });

  useEffect(() => {
    const desired =
      getTabFromQueryRaw(location.search) ||
      localStorage.getItem("TargetTabsActive") ||
      "targetFlow";

    const existsDesired = tabs.some((t) => t.key === desired);
    const existsActive = tabs.some((t) => t.key === active);

    if (existsDesired && active !== desired) {
      setActive(desired);
      return;
    }

    if (!existsActive) setActive(tabs[0]?.key || "targetFlow");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs.length]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("tab") !== active) {
      params.set("tab", active);
      navigate({ search: params.toString() }, { replace: true });
    }
    localStorage.setItem("TargetTabsActive", active);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  const renderActivePane = () => {
    if (active === "targetFlow") return <YearlyTargetTab />;
    if (active === "autoTarget") return <AutoCompanyTarget />;
    if (active === "smTarget") return <SalesManagerTargetTab />;
    if (active === "spTarget") return <SalesPersonTargetTab />;
    if (active === "customerTarget") return <CustomerTargetTab />;
    if (active === "profitWiseReport") return <ProfitWiseReport />;
    return <div className="fb">No tab selected</div>;
  };

  return (
    <>
      <Row>
        <Col sm="12">
          <Card className="tt-nav">
            <Nav pills>
              {tabs.map((t) => (
                <NavItem key={t.key}>
                  <NavLink
                    className={`tt-link ${active === t.key ? "active" : ""}`}
                    onClick={() => setActive(t.key)}
                  >
                    {t.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </Card>
        </Col>
      </Row>

      <Row style={{ marginTop: 10 }}>
        <Col sm="12">
          <Card className="tt-body">
            <CardBody>{renderActivePane()}</CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
}
